import React, { useEffect, useMemo, useState } from 'react';
import { useAccess } from '../../Context/AccessContext';

const HeaderDropdown = ({ children, label='' }) => {

    const { getAccess, accessLoaded } = useAccess();

    const show = useMemo(() => {
        if(!accessLoaded) return false;
        let returnValue;
        React.Children.forEach(children, child => {
            if(child.props.acesso && getAccess(child.props?.acesso)?.opcao_menu){
                returnValue = true;
            }
        });
        return returnValue;
    }, [accessLoaded, getAccess, children]);

    if(show){
        return (
            <li>
                <button>
                    { label }
                </button>
                <ul>
                    { children }
                </ul>
            </li>
        );
    }
    return;
};

export default HeaderDropdown;